module.exports = __webpack_public_path__ + "img/Grejanje_GROUND_HEATING.3af4d325.svg";